module.exports = __webpack_public_path__ + "static/6-10ddf705ce8ff6154c9fe1c5fe9011b2.png";